import { Process } from 'shared/domain/process/types/model';

const PROCESS_CODE_BY_ID: Record<string, string> = Object.values(Process).reduce(
  (result, processId) => {
    result[processId] = processId.replace(/^PROCESS_/, '');
    return result;
  },
  {} as Record<string, string>
);

export function resolveIssueProcessCode(processId: string): string {
  return PROCESS_CODE_BY_ID[processId] ?? processId.replace(/^PROCESS_/, '');
}

export function buildIssueNumber(params: {
  createdAt: string;
  processId: string;
  siteCode: string;
  hashtag: string;
}): string {
  const { createdAt, processId, siteCode, hashtag } = params;
  const year = new Date(createdAt).getFullYear().toString();
  const processCode = resolveIssueProcessCode(processId);

  return `${year}/${processCode}/${siteCode}/${hashtag}`;
}

export function normalizeIssueNumberForSearch(value: string): string {
  return value
    .trim()
    .replace(/^#/, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}
